const browsersUpdateUrl = {
    chrome: 'https://www.google.com/chrome',
    firefox: 'https://www.mozilla.org/en-US/firefox/new/',
    safari: 'https://www.apple.com/safari/',
    edge: 'https://www.microsoft.com/en-us/microsoft-edge'
};

const globalDeprecatedDefinition = [
    {
        browser: 'chrome',
        version: '>=85',
    },
    {
        browser: 'firefox',
        version: '>=74',
    },
    {
        browser: 'edge',
        version: '>=84',
    },
    {
        browser: 'safari',
        version: '>=14.1',
    },
];

export {
    browsersUpdateUrl,
    globalDeprecatedDefinition
};